/* import __COLOCATED_TEMPLATE__ from './event-part-assignment-strategy-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();